import { setExtras } from '@sentry/react';
import type { SetRequired } from 'type-fest';

import { NetworkError } from './types';

const generateErrorName = (error: NetworkError) => {
  const { method, url } = error.config || {};
  return `${method?.toUpperCase() || '<unknown>'} at ${url || '<unknown>'} failed with ${error.response?.status} code`;
};

const getPayload = (data: unknown) => {
  if (typeof data === 'string') {
    return JSON.parse(data);
  }
  if (data instanceof FormData) {
    const payload = {
      formData: {},
    };

    data.forEach((value, key) => {
      payload.formData = {
        ...payload.formData,
        [key]: value,
      };
    });
    return payload;
  }
  return data;
};

export function setExtraInfo(error: SetRequired<NetworkError, 'response'>) {
  const data = error.config?.data;
  const payload = getPayload(data);

  setExtras({
    rootStack: error.stack,
    params: error.config?.params,
    code: error.code,
    status: error.response?.status,
    statusText: error.response?.statusText,
    response: error.response?.data,
    payload,
  });
}

export function setStackTrace(error: NetworkError, newError: Error) {
  const { stack } = newError;
  Object.assign(newError, error);
  const message = generateErrorName(error);

  // eslint-disable-next-line no-param-reassign
  newError.message = message;
  // eslint-disable-next-line no-param-reassign
  newError.stack = stack;
}

export function matchesResponseStatus(statuses: number[]) {
  return (response: NetworkError['response']) => Boolean(response?.status && statuses.includes(response.status));
}
